// this is an autogenerated file from DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_ManualAutomations_Content_Content_ActiveAction_CreateProcedureReceivables_Content($id: uuid!) {
  vaxiom_appointments(where: { _id: { _eq: $id } }) {
    id
    appointment_procedures {
      appointment_id
      procedure_id
      procedure {
        id
        procedure_misc_fee_charge_templates {
          procedure_id
          misc_fee_charge_template_id
          misc_fee_charge_template {
            id
            name
            price
            is_included_in_insurance_claim
            affecting_production_report
            insurance_code_id
            requires_tooth_details
          }
        }
      }
    }
  }
}

`